/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Bid_IncreaseInputs */

const en_directory_vibebids_bid_increase = /** @type {(inputs: Directory_Vibebids_Bid_IncreaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase bid by one dollar`)
};

const zh_directory_vibebids_bid_increase = /** @type {(inputs: Directory_Vibebids_Bid_IncreaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将出价提高 1 美元`)
};

/**
* | output |
* | --- |
* | "Increase bid by one dollar" |
*
* @param {Directory_Vibebids_Bid_IncreaseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_bid_increase = /** @type {((inputs?: Directory_Vibebids_Bid_IncreaseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Bid_IncreaseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_bid_increase(inputs)
	return zh_directory_vibebids_bid_increase(inputs)
});
export { directory_vibebids_bid_increase as "directory.vibebids.bid_increase" }